import { Directive, ElementRef, OnDestroy, Renderer } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { EventService } from './event.service';

@Directive({
  selector: '[appFocusable]'
})
export class FocusableDirective implements OnDestroy {

  private id: string;
  private subscription: Subscription;

  constructor (private element: ElementRef,
              private renderer: Renderer,
              private eventService: EventService
              ) {

    this.id = this.element.nativeElement.attributes['id'].nodeValue;

    this.subscription = eventService.focusFieldRequested$.subscribe(id => {
      if (id === this.id) {
        setTimeout(() => {
          this.renderer.invokeElementMethod(this.element.nativeElement, 'focus');
        }, 0); // TODO: investigate if this timeout is needed
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}




// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/focusable.directive.ts